import type { MediaConfig, NavigationMode } from './types';

export const getTransitionDuration = (navigationMode: NavigationMode, config: MediaConfig): number => {
  const { transitionDuration, transitionDurationAutoplay, transitionDurationManual } = config;

  switch (navigationMode) {
    case 'autoplay':
      return transitionDurationAutoplay ?? transitionDuration;
    case 'manual':
      return transitionDurationManual ?? transitionDuration;
  }
};
